if (/msie\s|trident\//i.test(window.navigator.userAgent)) {
	document.write("Bitte Chrome verwenden.<br>Internet Explorer wird nicht unterstützt.");
}
